import { keys } from "./Keys";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { useQuery } from "react-query";
import { IEditDTO } from "../../services/notification-list-data-service/Models";
import NotificationListDataService from "../../services/notification-list-data-service/NotificationListService";

export type UseGetNotificationListParams = {
    groupID: number,
    notificationListID: number,
    organizationID: number,
} & BaseUseQueryParameters<IEditDTO | undefined>;

export function useGetNotificationList({
    groupID,
    organizationID,
    notificationListID,
    enabled,    
    onSuccess,
    onError
}: UseGetNotificationListParams) {
    return useQuery<IEditDTO, RestError>(
        keys.notificationList(groupID, organizationID, notificationListID),
        ({ signal }) => {
            return NotificationListDataService.getNotificationList(
                groupID,
                organizationID,
                notificationListID,
                signal
            );
        },
        {
            enabled,
            onError: onError,
            onSuccess: onSuccess,
            refetchInterval: false,
            staleTime: Infinity,
            refetchOnWindowFocus: false,
            refetchOnMount: true,
            refetchOnReconnect: false,
            retry: false,
        }
    );
}